import { AgreementType } from 'api/types';
import { isWelcomeChecklistRequired } from './getWelcomeChecklistStatus';

export const shouldLoadWelcomeChecklist = (dwcAgreement: AgreementType) =>
  dwcAgreement &&
  !dwcAgreement.is_tpv_installer &&
  isWelcomeChecklistRequired(dwcAgreement.welcome_checklist_status);

export default {};
